
export default class Volunteering{

  constructor(){
    this.document = null;
    this.question1 = null;
    this.question2 = null;
    this.question3 = null;
    this.question4 = null;
    this.question5 = null;
    this.question6 = null;
  }

  reset(){
    this.document = null;
    this.question1 = null;
    this.question2 = null;
    this.question3 = null;
    this.question4 = null;
    this.question5 = null;
    this.question6 = null;
  }

}